var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":_vm.id}},[(_vm.title)?_c('SectionHeader',{attrs:{"title":_vm.title}}):_vm._e(),_c('div',{staticClass:"content-area"},[_c('div',{class:{ 'grid-container': _vm.hasGrid }},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }